import { SpinnerWrapper } from "./Spinner.styles";

export const Spinner = () => {
  return (
    <SpinnerWrapper viewBox="0 0 20 20" x="0" y="0" className="spinner">
      <circle cx="10" cy="10" r="8"></circle>
    </SpinnerWrapper>
  )
}
